import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { BillingserviceService } from '../billingService.service';
import { CouriorDetails } from '../Models/corporatedetail.model';

@Component({
  selector: 'app-courier-details',
  templateUrl: './courier-details.component.html',
  styleUrls: ['./courier-details.component.scss']
})
export class CourierDetailsComponent implements OnInit {
  CouriorDetails: CouriorDetails = {};
  showspinner=false;
  constructor(public dialog: MatDialog, public dashboardService:DashboardService, public authService:AuthService,
    public dialogRef: MatDialogRef<CourierDetailsComponent>, public billingservice: BillingserviceService, private datePipe: DatePipe, public opdvisitService: OpdVisitService, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.getCouriorDetails(this.opdvisitService.patientdetails.pkRegId);
  }

  closeCouriordialog() {
    this.dialogRef.close();
  }
  // get Courior details 
  getCouriorDetails(regid:any) {
    this.CouriorDetails ={};
    this.showspinner=true;
    this.billingservice.GetCouriorDetail(regid).subscribe(item => {
      this.showspinner=false;
      if (item.pk_TranId != null) {
        this.CouriorDetails.PK_TranId = item.pk_TranId;
      } else {
        this.CouriorDetails.PK_TranId = 0;
      }
     
      if (item.fK_RegId != null) {
        this.CouriorDetails.FK_RegId = item.fK_RegId
      }else{
        this.CouriorDetails.FK_RegId = regid;
      }
      this.CouriorDetails.CourierName =item.courierName;
      this.CouriorDetails.DocketNo = item.docketNo;
      this.CouriorDetails.ContactNo = item.contactNo;
      this.CouriorDetails.Address = item.address;
      this.CouriorDetails.City = item.city; 
      this.CouriorDetails.ContactPerson = item.contactPerson;
      if (item.courierDate != null) {
        this.CouriorDetails.CourierDate = this.datePipe.transform(item.courierDate, "yyyy-MM-dd");
      } else {
        const newdate = this.authService.getServerDate;
        this.CouriorDetails.CourierDate = this.datePipe.transform(newdate, "yyyy-MM-dd");
      }
    
    });

  }
// save and update Courior details 
  SaveCouriorData(formvalidation :any){

    if(formvalidation ==true){
     if(this.CouriorDetails.PK_TranId ==0){
       this.showspinner=true;
      this.billingservice.InsertCouriorDetail(this.CouriorDetails).subscribe(item =>{
        this.showspinner=false;
        if(item.id !=null){
          this.getCouriorDetails(this.opdvisitService.patientdetails.pkRegId);
          this.dashboardService.openSnackBar("Successfully Save Courior Details", "OK");
        }else{
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
     }else{
      this.billingservice.InsertCouriorDetail(this.CouriorDetails).subscribe(item =>{
        if(item.id !=null){
          this.getCouriorDetails(this.opdvisitService.patientdetails.pkRegId);
          this.dashboardService.openSnackBar("Successfully Update Courior Details", "OK");
        }else{
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
     }
    }else{
      this.dashboardService.openSnackBar("All Field are required", "OK");
    }
  }


}
